
























import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {State} from 'vuex-class'
import {Version} from '@/store/types'

@Component
export default class About extends Vue {
    @State
    public version: Version

    @Prop({type: Boolean, default: false})
    public value: boolean
}
